import Cookies from 'js-cookie'

/**
 * Examples:
 * Cookies.set('name', 'value', { expires: 365 })
 * Cookies.get('name') // => 'value'
 * Cookies.remove('name')
 * @returns Cookies
 */
export const useCookies = ()=>{
	return Cookies;
}